/* Ancestral Brotherhood — the torch, site-wide.
 *
 * Loaded (deferred) from snippets/ab-motion.liquid.
 *
 * A warm pool of light follows the cursor across a card's picture while the
 * rest of it falls into shadow. The gradients, the falloff and the flicker
 * are all CSS in ab-alive.css; this file does two things only: it puts the
 * beam element where it needs to be, and it writes the pointer position.
 *
 * The beam is INJECTED rather than authored into each section. Adding a new
 * surface is one entry in HOSTS, not a template edit — which also means the
 * markup Shopify renders stays clean for anyone reading it in the theme
 * editor.
 *
 * Fine pointers only. There is no cursor to follow on a phone, and :hover
 * sticks there after a tap, so a touch visitor would be left with one card
 * lit until they tapped something else.
 */
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!fine.matches) return;

  /* host selector -> the child that holds the picture */
  var HOSTS = [
    ['.ab-mrc__card', '.ab-mrc__media'],
    ['.ab-proof__item', '.ab-proof__media'],
    ['.ab-clasp', '.ab-clasp__media'],
    ['.ab-community__frame', '.ab-community__media']
  ];

  var hosts = [];

  function mount() {
    HOSTS.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (host) {
        // The Apothecary ships its own beam in ab-sup.js. Two listeners on
        // one card would fight over the same custom properties.
        if (host.closest('.ab-sup')) return;
        if (host.__abTorch) return;

        var media = host.querySelector(pair[1]) || host;
        if (media.querySelector(':scope > .ab-torch')) return;

        var beam = document.createElement('span');
        beam.className = 'ab-torch';
        beam.setAttribute('aria-hidden', 'true');
        media.appendChild(beam);

        host.classList.add('is-torchable');
        host.__abTorch = beam;
        hosts.push(host);
      });
    });
  }

  var frame = 0;
  var pending = null;

  function onMove(e) {
    var host = e.target.closest ? e.target.closest('.is-torchable') : null;
    if (!host || !host.__abTorch) return;
    pending = { host: host, x: e.clientX, y: e.clientY };
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = 0;
      if (!pending) return;
      var r = pending.host.getBoundingClientRect();
      var beam = pending.host.__abTorch;
      beam.style.setProperty('--tx', (((pending.x - r.left) / r.width) * 100).toFixed(1) + '%');
      beam.style.setProperty('--ty', (((pending.y - r.top) / r.height) * 100).toFixed(1) + '%');
    });
  }

  // Leaving a card parks the beam in the middle, so the next hover does not
  // fade in from wherever the last one happened to end.
  function onOut(e) {
    var host = e.target.closest ? e.target.closest('.is-torchable') : null;
    if (!host || !host.__abTorch) return;
    if (e.relatedTarget && host.contains(e.relatedTarget)) return;
    host.__abTorch.style.setProperty('--tx', '50%');
    host.__abTorch.style.setProperty('--ty', '42%');
  }

  function start() {
    mount();
    if (!hosts.length) return;
    document.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointerout', onOut, { passive: true });

    // Sections can arrive late — the theme editor re-renders them, and some
    // are rendered by the Section Rendering API after first paint.
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { mount(); });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
